export default __webpack_public_path__ + "static/media/quickstart-step-6.50fd2663.jpg";